import {ReactComponent as Toileticon} from './icons/toilet-blue-thicker.svg';
import {Tooltip} from '@mui/material';
import Zoom from '@mui/material/Zoom';
import React from 'react';
import $ from 'jquery';

class record extends React.Component {
  flushClick(flushId) {
    // console.log(flushId);
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'poo_delete',
        pooId: flushId,
        message_id: $('.poo_delete').val()
      },
      cache: false,
      success: function(resp) {
        // console.log(resp['data'][0]);
        // this.setState({response: resp['data'][0]});
      }
    });
    window.location.reload(false);
  }

  getDiff(){
    let diff = new Date(parseInt(this.props.endTime)) - new Date(parseInt(this.props.startTime))
    // console.log(diff)
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const hours = Math.floor((diff / 1000 / 60 / 60));

    return(
      <p>
        {hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}
      </p>
    )
  }

  render() {
    return (
      <div className={"record-container"}>
        <span className="tp-roll" />
        <div className="tp-bg">
          {<p className="mobile-hidden"><span>{new Date(parseInt(this.props.startTime)).toLocaleString([], {month: '2-digit', day: '2-digit'})}</span>{new Date(parseInt(this.props.startTime)).toLocaleString([], {hour: 'numeric', minute: '2-digit'})}</p>}
          {<p className="mobile-hidden"><span>{new Date(parseInt(this.props.endTime)).toLocaleString([], {month: '2-digit', day: '2-digit'})}</span>{new Date(parseInt(this.props.endTime)).toLocaleString([], {hour: 'numeric', minute: '2-digit'})}</p>}
          {this.getDiff()}
          {<p className={'poo-type' + this.props.pooType}></p>}
        </div>
        <span className="toilet-icon-blue tp-end">
          <Tooltip title="Flush Result" placement="right" arrow TransitionComponent={Zoom} TransitionProps={{ timeout: 500 }}>
            <Toileticon style={{cursor: 'pointer'}} onClick={() => {this.flushClick(this.props.id)}} width="10%"/>
          </Tooltip>
        </span>
      </div>
    );
  }
};

export default record;
